export default function Section15() {
  return (
    <div className="w-full bg-white Section1 py-[30px] md:py-[50px]">

      {/* Main Page Heading */}
      

      {/* Hero Content */}
      <div className="w-[90%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        {/* Left Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-[26px] md:text-[30px] font-bold text-[#DA2128] -mt-10 md:mt-0 leading-[34px] mb-6">
            500+ Ecommerce Projects with Proven Results
          </h2>

          <p className="text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-10 max-w-[500px] mx-auto md:mx-0">
           With a proven track record of 500+ successful ecommerce builds, we help Texas brands launch, scale, and optimize Shopify stores that deliver real business results.
 Our approach combines performance, user experience, and conversion strategy to drive consistent growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="https://mean3.com/contact-mean3"
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              Get a Free Consultation
            </a>

            <a
              href="https://mean3.com/contact-mean3"
              className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              View Our Work
            </a>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="/assets/e-commerce-journey-WebDevPage.png"
            alt="Web Development Illustration"
            className="w-[90%] md:w-[80%] max-w-[500px]"
          />
        </div>
      </div>




    </div>
  );
}
